import { append } from 'ramda';

import { IColumn } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import { ComparisonSetting } from '../Components/EkonomiskAnalysColumnSelect/EkonomiskAnalysColumnSelect';
import { clone } from 'ramda';
import { IColumnTemplate } from '../../Queries/AvailableColumnTemplatesHandler';
import Logger from '../../../../../../../../../../../Utils/Logger';

export const getWithComparisonColumns = (
  columns: IColumn[],
  setting: ComparisonSetting
): IColumn[] => {
  if (setting === ComparisonSetting.none) {
    return columns;
  }

  const newColumns: IColumn[] = [];
  let id = 0;
  columns.forEach(column => {
    column.id = id;
    column.data.LOPNR = id;
    const comparisonColumn = clone(column);
    comparisonColumn.id = id + 1;
    comparisonColumn.data.LOPNR = id + 1;
    comparisonColumn.data.FROM_AR = column.data.FROM_AR
      ? column.data.FROM_AR - 1
      : -1;

    newColumns.push(column);
    newColumns.push(comparisonColumn);
    id += 2;
  });

  return newColumns;
};

export const templateCanHavePreviousYear = (
  templateId: string,
  availableTemplates: IColumnTemplate[]
): boolean => {
  if (!templateId) {
    return true;
  }

  const template = availableTemplates.find(
    template => template.id === templateId
  );

  if (template == null) {
    Logger.error(Error(`Could not find template with id: ${templateId}`));
    return true;
  }

  return template.canHavePrevYearCols;
};

const addPrevYearColumnReducer =
  (length: number) =>
  (newColumns: IColumn[], currentColumn: IColumn, index: number): IColumn[] => {
    const prevYearColumn: IColumn = {
      ...currentColumn,
      id: length + index,
      displayLabel: undefined,
      data: {
        ...currentColumn.data,
        FROM_AR:
          currentColumn.data.FROM_AR != null
            ? currentColumn.data.FROM_AR - 1
            : null,
        TOM_AR:
          currentColumn.data.TOM_AR != null
            ? currentColumn.data.TOM_AR - 1
            : null,
      },
    };

    newColumns = append(prevYearColumn, newColumns);
    newColumns = append(
      { ...currentColumn, id: index, displayLabel: undefined },
      newColumns
    );

    return newColumns;
  };

/**
 * Duplicates all columns in the array with a column of the previous year
 * The new column of the previous year is added before the old column
 */
export const addPrevYearCols = (columns: IColumn[]): IColumn[] => {
  const newColumns = columns.reduce(
    addPrevYearColumnReducer(columns.length),
    []
  );

  return newColumns;
};

const isResultColumn = (column: IColumn): boolean =>
  Boolean(
    column.data.FALTKOD &&
      (column.data.FALTKOD === 'PERVARDE' ||
        column.data.FALTKOD === 'PERINGVARDE' ||
        column.data.FALTKOD === 'PERUTGVARDE' ||
        column.data.FALTKOD === 'PERBUDGET' ||
        column.data.FALTKOD === 'PERINGBUDGET' ||
        column.data.FALTKOD === 'PERUTGBUDGET' ||
        column.data.FALTKOD === 'ARETSVARDE' ||
        column.data.FALTKOD === 'ARETSINGBALANS' ||
        column.data.FALTKOD === 'ARETSUTGBALANS' ||
        column.data.FALTKOD === 'ARETSBUDGET')
  );

export const setVandTeckenIfResultColumn =
  (newVandTeckenValue: boolean) =>
  (column: IColumn): IColumn => {
    if (isResultColumn(column)) {
      column = {
        ...column,
        data: { ...column.data, VAND_TECKEN: newVandTeckenValue },
      };
    }

    return column;
  };

export const getColumnTemplateName = (
  name: string,
  prevYearCols: boolean,
  flipColumnSign: boolean
): string => {
  if (prevYearCols) {
    name = `${name} föregående år`;
  }

  if (flipColumnSign) {
    name = `Teckenvänd ${name.toLowerCase()}`;
  }

  return name;
};

export const getColumnMaxId = (columns: IColumn[]): number => {
  const maxId =
    columns.length === 0
      ? 0
      : columns.reduce((x, y) => (x.id > y.id ? x : y)).id;

  return maxId;
};

export const getNextColumnId = (columns: IColumn[]): number => {
  const nextId = getColumnMaxId(columns) + 1;

  return nextId;
};
